var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.kind,{tag:"component",class:[_vm.type, {'heading-with-icon' : _vm.icon}, {'heading-with-image' : _vm.image}]},[(_vm.icon)?_c('span',{class:`icon icon-${_vm.icon}`}):_vm._e(),_vm._v(" "),(_vm.image)?_c('img',{attrs:{"src":_vm.image}}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }